import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");

  useEffect(() => {
    if (!token || !refreshToken) {
      navigate("/login", { replace: true });
    }
  }, [token, refreshToken, navigate]);

  // If token is missing, return null temporarily while redirect happens
  if (!token || !refreshToken) return null;

  return children;
};

export default PrivateRoute;
